import { INotification } from "infrastructure/notification";
import { IPickerSearchCriterion } from "ui/screens/security/shared/picker";

export interface ISecurityRoleSearchCriterion extends IPickerSearchCriterion<ISecurityRole> {
  tenantId?: string;
  enterpriseId?: string;
}

export interface ISecurityRole {
  securityRoleId: string;
  name: string;
}

export interface ISecurityRolesState {
  [x: string]: ISecurityRolesList;
}

export interface ISecurityRolesList {
  items: ISecurityRole[];
  isLoading: boolean;
  initialized: boolean;
  notification?: INotification;
}

export const getInitialSecurityRolesState = (): ISecurityRolesState => {
  return {};
};
